import { localStorageGetItem, localStorageSetItem } from 'entrypoints/storage_helpers';

function getNewExpireTime() {
  const validDays = 14;
  const now = Date.now(); // In ms

  // Has to convert to valid days to ms
  return now + validDays * 24 * 60 * 60 * 1000;
}

export function clearAnswersInStorage(storeKey: string) {
  localStorageSetItem(storeKey, JSON.stringify({}));
}

export function resetAnswer(storeKey: string) {
  const sessionAnswers = {
    wasReset: true,
  };
  localStorageSetItem(storeKey, JSON.stringify(sessionAnswers));
  return sessionAnswers;
}

export function getAnswersFromStorage(storeKey: string) {
  const sessionAnswers = localStorageGetItem(storeKey);
  const parsedSessionAnswers = JSON.parse(sessionAnswers || '{}');

  // If answer has expires, clear storage
  if (parsedSessionAnswers?.expireTime && parsedSessionAnswers?.expireTime < Date.now()) {
    return resetAnswer(storeKey);
  }

  // Sync answers from answers if coming from CMS 2.0 tofu survey
  parsedSessionAnswers.NUMBER_EMPLOYEES_SEGMENTATION = localStorageGetItem(
    'NUMBER_EMPLOYEES_SEGMENTATION'
  );
  parsedSessionAnswers.PREV_PAYROLL_PROVIDER = localStorageGetItem('PREV_PAYROLL_PROVIDER');
  parsedSessionAnswers.INDUSTRY_IDENTIFICATION = localStorageGetItem('INDUSTRY_IDENTIFICATION');

  return parsedSessionAnswers;
}

export function storeAnswerToStorage(key: string, val: string, storeKey: string) {
  const currentSessionAnswers = getAnswersFromStorage(storeKey);
  currentSessionAnswers[key] = val;
  currentSessionAnswers.expireTime = getNewExpireTime();
  localStorageSetItem(storeKey, JSON.stringify(currentSessionAnswers));
}
